import { useCallback } from 'react';
import { UI } from '../data/strings';
import type { UiKey } from '../data/strings';
import { useSettings } from '../state/SettingsContext';

/** Returns the interface string for the current display language. */
export function useT(): (key: UiKey) => string {
  const { uiLang } = useSettings();
  return useCallback((key: UiKey) => UI[key][uiLang], [uiLang]);
}

/** Returns both languages, for places that show Arabic with English underneath. */
export function useBoth(): (key: UiKey) => { ar: string; en: string } {
  return useCallback((key: UiKey) => UI[key], []);
}
